/**
 * 途经点编辑禁用配置
 *
 * 按 routeType 分类，每种 routeType 下按 businessType-waypointType 配置。
 * 命中配置且 waypointStatus 在列表中时，禁止编辑步骤详情。
 * 未命中配置走原逻辑（任务未完成即可编辑）。
 *
 * |------------|--------------|----------------|-----------------|-------------------|
 * | routeType  | businessType | 始发站(Origin)  | 途经点(Waypoint) | 终点(Destination)  |
 * |------------|--------------|----------------|-----------------|-------------------|
 * | 交接        | TikTok      | Done 后禁编辑    | —               | —                 |
 * | 交接        | TemuGA      | Done 后禁编辑    | —               | —                 |
 * | 干线/支线   | TemuGA       | Done 后禁编辑    | —               | Arrived 后禁编辑   |
 * | 干线/支线   | TemuSCF      | Done 后禁编辑    | Done 后禁编辑    | Arrived 后禁编辑   |
 * | 干线/支线   | OwnRoute     | 无限制          | 无限制           | 无限制             |
 * |------------|--------------|----------------|-----------------|-------------------|
 */
import {
    WaypointTypeEnum,
    TmsRouteTypeEnum,
    TmsBusinessTypeEnum,
    TmsTaskWaypointStatusEnum,
} from '../../../../enums/TmsEnum';

// ===== 交接 =====
const HANDOVER_EDIT_DISABLED: Record<string, number[]> = {
    // TikTok：始发站发车后不可编辑
    [`${TmsBusinessTypeEnum.TikTok}-${WaypointTypeEnum.Origin}`]: [TmsTaskWaypointStatusEnum.Done],
    // TemuGA：始发站发车后不可编辑
    [`${TmsBusinessTypeEnum.TemuGA}-${WaypointTypeEnum.Origin}`]: [TmsTaskWaypointStatusEnum.Done],
};

// ===== 干线 =====
const LINEHAUL_EDIT_DISABLED: Record<string, number[]> = {
    // TemuGA：始发站发车后不可编辑
    [`${TmsBusinessTypeEnum.TemuGA}-${WaypointTypeEnum.Origin}`]: [TmsTaskWaypointStatusEnum.Done],
    // TemuGA：终到站到达后不可编辑
    [`${TmsBusinessTypeEnum.TemuGA}-${WaypointTypeEnum.Destination}`]: [TmsTaskWaypointStatusEnum.Arrived],
    // TemuSCF：始发站发车后不可编辑
    [`${TmsBusinessTypeEnum.TemuSCF}-${WaypointTypeEnum.Origin}`]: [TmsTaskWaypointStatusEnum.Done],
    // TemuSCF：途经点发车后不可编辑
    [`${TmsBusinessTypeEnum.TemuSCF}-${WaypointTypeEnum.Waypoint}`]: [TmsTaskWaypointStatusEnum.Done],
    // TemuSCF：终到站到达后不可编辑
    [`${TmsBusinessTypeEnum.TemuSCF}-${WaypointTypeEnum.Destination}`]: [TmsTaskWaypointStatusEnum.Arrived],
};

// ===== 支线（同干线）=====
const FEEDER_EDIT_DISABLED = LINEHAUL_EDIT_DISABLED;

/** 按 routeType 映射编辑禁用配置 */
const EDIT_DISABLED_BY_ROUTE_TYPE: Record<number, Record<string, number[]>> = {
    [TmsRouteTypeEnum.Handover]: HANDOVER_EDIT_DISABLED,
    [TmsRouteTypeEnum.Linehaul]: LINEHAUL_EDIT_DISABLED,
    [TmsRouteTypeEnum.Feeder]: FEEDER_EDIT_DISABLED,
};

/** 根据配置表判断当前途经点是否禁止编辑 */
export function isEditDisabledByConfig(
    waypointType: number,
    waypointStatus: number,
    businessType?: number,
    routeType?: number,
): boolean {
    if (routeType == null || businessType == null) return false;

    const config = EDIT_DISABLED_BY_ROUTE_TYPE[routeType];
    if (!config) return false;

    const key = `${businessType}-${waypointType}`;
    const disabledStatuses = config[key];
    if (!disabledStatuses) return false;

    return disabledStatuses.includes(waypointStatus);
}
